<template></template>

<script>
// Export the root component as named export.
export const BaseDetail = {
  name: "BaseDetail"
  // ...
};

// Proxy export all related components.
export { default as detailChargebackPage } from "./chargebackdetail";
export { default as detailCryptoPage } from "./cryptodetail";
export { default as detailEcheckPage } from "./echeckdetail";
export { default as detailMerchantPage } from "./merchantappdetail";

// A Vue.js SFC must have a default export.
export default BaseDetail;
</script>